if (customElements && !customElements.get('decorative-line')) {
  class DecorativeLine extends HTMLElement {
    static _resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        entry.target._fitPattern()
      }
    });

    connectedCallback() {
      this._fitPattern();
      DecorativeLine._resizeObserver.observe(this);
    }

    disconnectedCallback() {
      DecorativeLine._resizeObserver.unobserve(this);
    }

    _fitPattern() {
      const elWidth = this.offsetWidth;
      if (!elWidth) return;

      const patternW = parseFloat(this.dataset.patternWidth) || 23;
      const patternH = parseFloat(this.dataset.patternHeight) || 28;
      const count = Math.max(1, Math.round(elWidth / patternW));
      const fittedWidth = elWidth / count;

      this.style.backgroundSize = `${fittedWidth}px ${patternH}px`;
    }
  }

  customElements.define('decorative-line', DecorativeLine);
}